document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.js-hero-slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".js-hero-slider .swiper-button-next",
            prevEl: ".js-hero-slider .swiper-button-prev",
        },
        pagination: {
            el: '.js-hero-slider .swiper-pagination',
            clickable: true
        }
    });

    document.querySelectorAll('.js-products').forEach((item) => {
        new Swiper(item.querySelector('.js-products-carousel'), {
            slidesPerView: 'auto',
            spaceBetween: 10,		
            loop: true,
            preloadImages: false,
            speed: 400,
            navigation: {
                nextEl: item.querySelector('.js-products-next'),
                prevEl: item.querySelector('.js-products-prev'),
            },
            // pagination: {
            //     el: item.querySelector('.swiper-pagination'),
            //     clickable: true
            // },
            breakpoints: {
                0: {
                    spaceBetween: 10,
                    slidesPerView: 1.3,
                },
                480: {
                    spaceBetween: 10,
                    slidesPerView: 2.2,
                },
                768: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                992: {
                    spaceBetween: 20,
                    slidesPerView: 4,
                },
            },
        });
	});

    document.querySelectorAll('.js-prptoduct').forEach((item) => {
        new Swiper(item.querySelector('.js-prptoduct-photos-carousel'), {
            slidesPerView: 'auto',
            spaceBetween: 10,		
            loop: true,
            preloadImages: false,
            speed: 400,
            navigation: {
                nextEl: item.querySelector('.js-prptoduct-photos-next'),
                prevEl: item.querySelector('.js-prptoduct-photos-prev'),
            },
            // pagination: {
            //     el: item.querySelector('.swiper-pagination'),
            //     clickable: true
            // },
            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                },
                480: {
                    slidesPerView: 2.2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
            },
        });
	});
    
    $('body').on('click', '[data-scroll]', function(e){
        e.preventDefault();
		var hash = '#'+$(this).attr("data-scroll");
		
		$('html, body').stop().animate({
	        	scrollTop: $(hash).offset().top-100
	        }, 800);
	});
})    